import axiosInstance from "./index.js"

export const getUserInfo = async (username) => {
  try {
    const response = await axiosInstance.get(`/profile/getUserInfoByUserName/${username}`);
    return response?.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.detail ||
      error?.message ||
      "Failed to load job titles";
    throw new Error(message);
  }
};


export const updateUserInfo = async (payload) => {
  try {
    const response = await axiosInstance.put("/profile/updateUser", payload);
    return response?.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.detail ||
      error?.message ||
      "Failed to load job titles";
    throw new Error(message);
  }
};